module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-10-b2c428ae564fff4bacdb58b30cacf902.svg";